<div [ngClass]="type">
    <div *ngIf="!readOnly" class="form-group compact inline-control">
        <ng-content select="div[role=header]"></ng-content>
        <select id="dropDownItemList" [(ngModel)]="selectedListItem" [disabled]="readOnly">
            <option *ngFor="let item of dropdownItems" [ngValue]="item">
                {{item.displayValue}}
            </option>
        </select>
        <button type="button" class="compact" (click)="onAdd()" [disabled]="readOnly">
            <span class="icon-plus"></span> {{acceptText}}
        </button>
    </div>
    <ng-content select="ul[role=list]"></ng-content>
    <table role="list"class="condensed">
        <thead>
            <tr>
                <th *ngFor="let column of columns">{{column}}</th>
                <th><span class="offscreen"></span></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of rows" class="compact">
                <td *ngFor="let cell of row.cells" >
                    <select *ngIf="cell.type == 'list'"
                        class="compact" 
                        id="dropDownItemList" 
                        [(ngModel)]="cell.value" 
                        [disabled]="readOnly || skipRowUpdate"
                        (change)="onCellChange(cell.id, row.id, $event.target.value)">
                        <option *ngFor="let option of cell.options" [value]="option">{{option}}</option>
                    </select>
                    <input *ngIf="cell.type == 'checkBox'" 
                        type="checkbox" 
                        class="compact" 
                        name="checkbox-{{ row.id }}"
                        [disabled]="readOnly || cell.readOnly || skipRowUpdate"
                        (change)="onCellChange(cell.id, row.id, $event.target.checked)" 
                        [checked]="cell.value">
                    <div *ngIf="!cell.type">{{ cell.value }}</div>
                </td>
                <td><button *ngIf="!readOnly" type="button" class="compact" id="{{row.id}}" (click)="onRemove(row.id)" [disabled]="readOnly"><span  class="icon-bin"></span> Remove</button></td>
            </tr>
        </tbody>
    </table>
</div>
